import { render, staticRenderFns } from "./CloneDefaultUsers.vue?vue&type=template&id=60d100f8"
import script from "./CloneDefaultUsers.vue?vue&type=script&lang=js"
export * from "./CloneDefaultUsers.vue?vue&type=script&lang=js"
import style0 from "./CloneDefaultUsers.vue?vue&type=style&index=0&id=60d100f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports